import { IBridgeLoanGridRecord } from '@apply/api/src/api/loanApi';

enum LoanDefaultStatus {
    NeverDefaulted,
    Cured,
    InDefault,
}

const barColors: Record<LoanDefaultStatus, string> = {
    [LoanDefaultStatus.NeverDefaulted]: '#A8E0A8',
    [LoanDefaultStatus.Cured]: '#F5C842',
    [LoanDefaultStatus.InDefault]: '#F07575',
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getLoanDefaultStatus = (_loan: IBridgeLoanGridRecord): LoanDefaultStatus => LoanDefaultStatus.NeverDefaulted;

// A thin bar colored by whether the loan has been in default
export const defaultStatusBarRender = (loan: IBridgeLoanGridRecord) => (
    <div
        style={{
            width: 3,
            height: 18,
            marginLeft: 'auto',
            backgroundColor: barColors[getLoanDefaultStatus(loan)],
        }}
    />
);
